(() => {
  const measurementId = 'G-TQ9P3818G9';
  const eventNames = {
    article_product_view: 'article_product_click',
    article_add_to_cart: 'article_add_to_cart',
    article_related_click: 'article_related_click',
    article_collection_click: 'article_collection_click',
    article_checklist_open: 'article_checklist_open',
    article_jump_to_set: 'article_jump_to_set',
  };
  const queue = [];
  let analyticsAllowed = false;
  let googleQueueReady = false;

  const internalDestinationPath = (value) => {
    if (!value) return '';
    try {
      const destination = new URL(value, window.location.href);
      return destination.origin === window.location.origin ? destination.pathname : '';
    } catch (_) {
      return '';
    }
  };

  const setStatus = (status, eventName = '') => {
    document.documentElement.dataset.tcgkingGa4Status = status;
    if (eventName) document.documentElement.dataset.tcgkingGa4LastEvent = eventName;
  };

  const normalisePayload = (eventName, eventData) => {
    const payload = { ...eventData };
    const destinationPath = internalDestinationPath(payload.destination_url || payload.product_url);
    if (destinationPath) payload.destination_path = destinationPath;
    const itemId = payload.variant_id || payload.product_id;
    if (itemId && !payload.items) {
      payload.items = [{
        item_id: String(itemId),
        item_name: payload.product_title || payload.product_handle || String(itemId),
        price: Number(payload.value || 0),
        quantity: 1,
      }];
    }
    payload.event_source = 'shopify_article';
    payload.send_to = measurementId;
    return payload;
  };

  const flush = () => {
    if (!analyticsAllowed || !googleQueueReady || typeof window.gtag !== 'function') return;
    while (queue.length) {
      const { eventName, eventData } = queue.shift();
      window.gtag('event', eventName, normalisePayload(eventName, eventData));
      setStatus('dispatched', eventName);
    }
  };

  const initialiseGoogleQueue = () => {
    if (!analyticsAllowed || googleQueueReady) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag('config', measurementId, { send_page_view: false });
    googleQueueReady = true;
    setStatus('ready');
  };

  const updateConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    analyticsAllowed = Boolean(privacy?.analyticsProcessingAllowed?.());
    if (analyticsAllowed) {
      initialiseGoogleQueue();
      flush();
    } else {
      setStatus('waiting_for_consent');
    }
  };

  window.tcgkingTrackArticleEvent = (eventName, eventData = {}) => {
    const ga4EventName = eventNames[eventName];
    if (!ga4EventName) return;
    queue.push({ eventName: ga4EventName, eventData });
    setStatus(analyticsAllowed ? 'queued' : 'waiting_for_consent', ga4EventName);
    if (analyticsAllowed) {
      initialiseGoogleQueue();
      flush();
    }
  };

  document.addEventListener('visitorConsentCollected', updateConsent);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) {
        setStatus('consent_api_error');
        return;
      }
      updateConsent();
    });
  } else {
    setStatus('consent_api_unavailable');
  }
})();
